document.addEventListener('DOMContentLoaded', function () {
  const heroSections = document.querySelectorAll('[data-wh-hero]');

  heroSections.forEach(function (hero) {
    const slides = hero.querySelectorAll('.wh-hero__slide');
    const dots = hero.querySelectorAll('.wh-hero__dot');
    const autoplay = hero.dataset.autoplay === 'true';
    const speed = parseInt(hero.dataset.speed, 10) || 6000;

    let currentSlide = 0;
    let timer = null;

    const tickerTracks = hero.querySelectorAll('.wh-hero__ticker-track');

tickerTracks.forEach(function (track) {

  if (track.dataset.cloned === 'true') return;

  const originalContent = track.innerHTML;

  track.innerHTML += originalContent;
  track.innerHTML += originalContent;

  track.dataset.cloned = 'true';
});

    if (slides.length <= 1) {
      dots.forEach(function (dot) {
        dot.style.display = 'none';
      });
      return;
    }

    function showSlide(index) {
      slides[currentSlide].classList.remove('is-active');

      if (dots[currentSlide]) {
        dots[currentSlide].classList.remove('is-active');
      }

      currentSlide = index;

      slides[currentSlide].classList.add('is-active');

      if (dots[currentSlide]) {
        dots[currentSlide].classList.add('is-active');
      }
    }

    function nextSlide() {
      const nextIndex = (currentSlide + 1) % slides.length;
      showSlide(nextIndex);
    }

    function startAutoplay() {
      if (!autoplay) return;

      stopAutoplay();
      timer = window.setInterval(nextSlide, speed);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const index = parseInt(dot.dataset.slideIndex, 10);

        if (!Number.isNaN(index)) {
          showSlide(index);
          startAutoplay();
        }
      });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});